// The table's rows for a stage: the reader's blunders and misses between two
// plies, each with the engine's move in SAN and the reader's record on its
// puzzle. Pure, so it is tested without React.
import { uciToInput, type Chess } from '@chess/api-chess';
import type { Color, Fen, Move } from '@chess/api-model';
import type { PuzzleStatus } from '@chess/api-puzzles';
import { momentsIn, positionOf, type MomentScan } from '@chess/api-review';
import type { MomentRow } from './MomentsTable.tsx';

/** What the rows read from the review session's state. */
export interface RowsView {
  game?: { moves: Move[]; positions: Fen[] };
  scan?: MomentScan;
  reader?: Color;
}

/**
 * The rows for the moves `fromPly + 1 … toPly`. Without the rules the engine's
 * move stays unnamed; without the puzzles API no row has a status.
 */
export function rowsOf(
  view: RowsView | undefined,
  fromPly: number,
  toPly: number,
  chess: Pick<Chess, 'play'> | undefined,
  statusOf?: (ply: number) => PuzzleStatus | undefined,
): MomentRow[] {
  const game = view?.game;
  if (!game) return [];
  return momentsIn(view.scan, game.moves, fromPly, toPly, view.reader).map((m) => {
    const fen = positionOf(game.positions, m);
    const bestSan = fen && chess ? chess.play(fen, uciToInput(m.best))?.move.san : undefined;
    return { ...m, bestSan, status: statusOf?.(m.ply) };
  });
}
